<template>
  <div class="change-plan">
    <HeaderBack page-name="プランを選択してください" @back="$emit('back')" />

    <div class="plan-and-payment">
      <p class="title">プラント支払い</p>

      <div>
        <p>{{planDescription}}</p>
        
        <div v-if="paymentType === 3" class="payment">
          <p>{{campaignName}}</p>
          <p>{{campaignStartDate}}</p>
        </div>
      </div>
    </div>

    <div class="line" />

    <div class="plan-cards-container">
      <div class="plan-cards">
        <div class="card">
          <img src="@/assets/plan_private.jpg">
          <button>選択</button>
        </div>

        <div class="card">
          <img src="@/assets/plan_premium.jpg">
          <button>選択</button>
        </div>

        <div class="card">
          <img src="@/assets/plan_standard.jpg">
          <button>選択</button>
        </div>

        <div class="card">
          <img src="@/assets/plan_light.jpg">
          <button>選択</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBack from '@/components/helpers/HeaderBack.vue'

export default {
  name: 'EditInformation',

  components: {
    HeaderBack
  },

  props: {
    planId: {
      type: Number || String,
      required: true
    },

    planDescription: {
      type: String,
      required: true
    },

    paymentType: {
      type: Number || String,
      required: true
    },

    campaignId: {
      type: Number || String,
      required: true
    },

    campaignName: {
      type: String,
      required: true
    },

    campaignStartDate: {
      type: String,
      required: true
    },
  },

  data() {
    return {
    }
  },

  mounted() {
  },

  methods: {
  }
}
</script>

<style scoped>
.change-plan .plan-and-payment {
  display: flex;
  margin-bottom: 15px;
}

.change-plan .plan-and-payment p {
  font-size: 12px;
  line-height: 18px;
}

.change-plan .plan-and-payment p.title {
  font-weight: 600;
  margin-right: 15px;
}

.change-plan .plan-and-payment .payment p {
  color: rgba(0, 0, 0, 0.6)
}

.change-plan .plan-and-payment .payment p:first-child {
  margin-bottom: -5px;
}

.change-plan .line {
  margin: 0 -20px 10px;
  height: 1px;
  background-color: #B6B6B6;
  opacity: 0.3;
}

.change-plan .plan-cards-container {
  margin: 0 -20px;
}

.change-plan .plan-cards {
  display: flex;
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}

.change-plan .plan-cards .card {
  width: 250px;
  height: 300px;
  margin-left: 20px;
}

.change-plan .plan-cards .card:last-child {
  padding-right: 20px;
}

.change-plan .plan-cards .card img {
  width: 250px;
  height: 216.66px;
  margin-bottom: 20px;
}

.change-plan .plan-cards .card button {
  width: 100%;
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 1.12px;
  color: #147efb;
  background-color: white;
  border: 1px solid #147efb;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.12);
}
</style>
